var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 20.5,
    viewBox: "0 0 10.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-attach-file",
    "data-name": "Icon material-attach-file",
    d: "M19.136,6.045V16.5a3.636,3.636,0,1,1-7.273,0V5.136a2.273,2.273,0,0,1,4.545,0v9.545a.909.909,0,0,1-1.818,0V6.045H13.227v8.636a2.273,2.273,0,0,0,4.545,0V5.136a3.636,3.636,0,0,0-7.273,0V16.5a5,5,0,1,0,10,0V6.045Z",
    transform: "translate(-10.25 -1.25)",
    fill: "#025376",
    stroke: "#03659a",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.905590d30ba4c268c34aa78eae4d93f7.svg";
export { ForwardRef as ReactComponent };